import { IconProps } from "../../utils/global-types/global-types";

const CopyIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <g clipPath="url(#clip0_3153_29032)">
      <g clipPath="url(#clip1_3153_29032)">
        <mask
          id="mask0_3153_29032"
          width="18"
          height="18"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
        >
          <path fill="#fff" d="M0 0h18v18H0z"></path>
        </mask>
        <g mask="url(#mask0_3153_29032)">
          <path
            fill="currentColor"
            d="M11.25.75H3c-.825 0-1.5.675-1.5 1.5V12c0 .412.337.75.75.75S3 12.412 3 12V3c0-.413.337-.75.75-.75h7.5c.412 0 .75-.338.75-.75a.75.75 0 0 0-.75-.75m3 3H6c-.825 0-1.5.675-1.5 1.5v10.5c0 .825.675 1.5 1.5 1.5h8.25c.825 0 1.5-.675 1.5-1.5V5.25c0-.825-.675-1.5-1.5-1.5m-.75 12H6.75A.75.75 0 0 1 6 15V6c0-.413.338-.75.75-.75h6.75c.412 0 .75.337.75.75v9c0 .412-.338.75-.75.75"
          ></path>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3153_29032">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
      <clipPath id="clip1_3153_29032">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default CopyIcon;
